import type { ReactNode } from 'react'

import { cn } from '../../lib/utils'

type KineticPageShellProps = {
  children: ReactNode
  className?: string
}

/**
 * Full-viewport Kinetic background + default text colour. Use inside main for pages
 * that should match the Stitch / workshop dark shell (not the old gray Section gradient).
 */
export function KineticPageShell({ children, className }: KineticPageShellProps) {
  return (
    <div className={cn('min-h-screen bg-kinetic-surface text-kinetic-on-surface', className)}>
      {children}
    </div>
  )
}
